import {CashierPaymentsWidgetLazy} from '@wix/cashier-payments-widget/lazy';
import classNames from 'classnames';
import * as React from 'react';
import {useSelector} from 'react-redux';
import {entityTypeSelector} from '../../services/albumProvider/albumProviderSelector';
import {currencySelector, finalPriceSelector} from '../../store/selectors/price.selector';
import {EmailEdit} from '../EmailEdit/EmailEdit.component';
import {GetSubtitle} from '../GetSubtitle';
import {GetTitle} from '../GetTitle/GetTitle';
import {StickyHeader} from '../ui/StickyHeader';
import {useCashierProps} from './CashierPaymentWidget.enhancers';
import styles from './CashierPaymentWidget.scss';
import {IInner} from './CashierPaymentWidget.types';

export const CashierPaymentWidget: React.FunctionComponent<IInner> = () => {
  const {props} = useCashierProps();
  const entityType = useSelector(entityTypeSelector);
  const finalPrice = useSelector(finalPriceSelector);
  const currency = useSelector(currencySelector);

  return (
    <div className={classNames(styles.cashierPaymentWidget)}>
      <StickyHeader>
        <GetTitle id="getContainerTitle" entityType={entityType} className={styles.getContainerTitle} />
        <GetSubtitle price={finalPrice} currency={currency} entityType={entityType} />
      </StickyHeader>
      <div className={styles.emailEdit}>
        <EmailEdit />
      </div>

      <div className={styles.widget}>
        <CashierPaymentsWidgetLazy {...props} />
      </div>
    </div>
  );
};

CashierPaymentWidget.displayName = 'CashierPaymentWidget';
